import { install } from "resize-observer";
import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import App from "./components/App/App";
import * as serviceWorker from "./serviceWorker";
import initializeFirebase from "./firebase/initialize";
import installGlobalErrorHandler from "./firebase/analytics/installGlobalErrorHandler";

if (!window.ResizeObserver) {
  install();
}

initializeFirebase({
  config: {
    apiKey: "AIzaSyBojL2JP3fFs9zQlwOO5cTRLDHEnmI4848",
    authDomain: "jupiter-ams-pilot.firebaseapp.com",
    databaseURL: "https://jupiter-ams-pilot-default-rtdb.firebaseio.com",
    projectId: "jupiter-ams-pilot",
    storageBucket: "jupiter-ams-pilot.appspot.com",
    messagingSenderId: "ENV_FIREBASE_PROJECT_ID",
    appId: "1:179078821549:web:2ce051e8339f8133533824",
    measurementId: "G-YYW8LT2S6B"
  }
});

installGlobalErrorHandler();

if (process.env.NODE_ENV === "production" && process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  });
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
